import { Badge, BadgeProps, Box, Button, Toolbar } from "@mui/material";
import { styled } from "@mui/system";
import { ComponentType } from "react";

export const StyledToolbar = styled(Toolbar)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  paddingLeft: "12px",
  paddingRight: "12px",
}));

export const NewOrderButton = styled(Button)(({ theme }) => ({
  width: "100%",
  height: "42px",
  borderRadius: "20px",
  margin: "16px 0",
  backgroundColor: theme.palette.primary.light,
  "&:hover": {
    backgroundColor: "#6D4AB5E5",
  },
  fontSize: "1rem",
}));

export const NavigationContainer = styled(Box)(() => ({
  width: "100%",
  textAlign: "center",
  padding: "6px 16px 8px 16px",
}));

export const ButtonContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  paddingRight: "16px",
  cursor: "pointer",
}));

export const StatusBadge = styled(({ ...props }: BadgeProps) => (
  <Badge
    variant="dot"
    overlap="circular"
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiBadge-badge": {
    height: 14,
    width: 14,
    minWidth: 14,
    padding: 0,
    borderRadius: "40%",
    boxShadow: `0 0 0 1px ${theme.palette.background.paper}`,
  },
})) as ComponentType<BadgeProps>;
